export function objectToArray(obj) {
  return Object.keys(obj).map(value => ({value,label:obj[value]}))
}
